// DeskPanel — the one shared "window" every My Desk element renders in
// (Request Ledger N-089, owner 2026-09-08: "My desk elements should be in
// windows that can hold the items being displayed instead of just being full
// page taking up so much room").
//
// A plain `.card` (D-37's ported review-document card: white, hairline
// border, 10px radius) with the site's ONE section head inside it (R-16 —
// `.section-head` is defined once, globally, and every page reuses it rather
// than inventing a heading style per surface). Nothing new is introduced
// here beyond the two tokens already governing every other panel on the
// site — this file only gives them one place to live so a panel is built the
// same way whether it holds an alert queue, a task queue, or a pinned board.
//
// `className` lets a specific panel opt into `.desk-panel-scroll` (own
// internal scroll, e.g. `max-height: 40vh`) on its own content, or add a
// panel-specific hook for CSS — this wrapper does not assume every panel
// scrolls; a short panel (a single alert row, four clinic tiles) has nothing
// to scroll and should not carry the class.
//
// `chromeless` (N-090c, owner, 2026-09-08 — "every panel shows its name
// twice") drops this wrapper's OWN `.section-head` (the `<h2>`/`<p>` this
// file has always rendered) when the caller is DeskGrid.tsx: that file's own
// title bar (client/src/components/DeskGrid.tsx's `.desk-panel-titlebar`) is
// now THE one heading a panel gets on the canvas, so a `DeskPanel` rendered
// inside it must not repeat the name/subtitle a second time just below.
// Defaults to false so every caller OUTSIDE the canvas — today, none, but
// this file makes no assumption about that — keeps its header exactly as
// before; only panelCatalog.tsx's `render()` calls pass `chromeless`.
import type { ComponentChildren, JSX } from 'preact';

export function DeskPanel(
  {
    title, subtitle, testId, className, chromeless = false, children,
  }: {
    title: string;
    subtitle?: string;
    testId?: string;
    className?: string;
    chromeless?: boolean;
    children: ComponentChildren;
  },
): JSX.Element {
  return (
    <div class={`card desk-panel${className ? ` ${className}` : ''}`} data-testid={testId}>
      {chromeless ? null : (
        <div class="section-head">
          <h2>{title}</h2>
          {subtitle ? <p>{subtitle}</p> : null}
        </div>
      )}
      {children}
    </div>
  );
}
